import React from 'react';
import Styled from 'styled-components';
import {GrowableColumn} from '../Elements.styled';

/**
 * Role name column
 * @param {String} name Name of role
 * @param {bool} noRole Is the role unassigened
 * @param {number} taskAmount the number of tasks with a given role 
 * @returns GrowableColumn
 */
export const RoleNameColumn = ({name, noRole, taskAmount}) => {
	return (
		<GrowableColumn>
			<Wrapper>
				<div>{name}</div>
				{noRole && <NoRoleTaskAmount>{'(' + taskAmount + ')'}</NoRoleTaskAmount>}
			</Wrapper>
		</GrowableColumn>
	);
};

export const Wrapper = Styled.div`
    display: flex;
    align-items: center;
`;

export const NoRoleTaskAmount = Styled.div`
	margin-left: 4px; 
	font-weight: 300;
`;